import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import type { PayoutStatus } from '../types/payouts.types'

type EditPayoutVariables = {
	id: number
	data: {
		status?: PayoutStatus
		tx_reference: string
	}
}

type UseEditPayoutMutationProps = {
	onSuccess: () => void
}

export const useEditPayoutMutation = ({ onSuccess }: UseEditPayoutMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: editPayoutMutation, isPending: isEditPayoutLoading } = useMutation({
		mutationFn: ({ id, data }: EditPayoutVariables) =>
			axiosPrivate.patch(apiRoutes.payout(String(id)), data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.payouts.all })
			useToast({ type: 'success', message: t('Payout status updated') })()
			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editPayoutMutation,
		isEditPayoutLoading
	}
}
